import { ReactElement } from 'react'
import styled, { css } from 'styled-components'
import { colors, fontScope, visuallyHidden } from '../tokens'

const VARIANTS = {
  table: css`
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
  `,
  mobile: css`
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
  `,
}

const Anchor = styled.span<{ $low: boolean, $variant: 'table' | 'mobile', $muted: string }>`
  ${fontScope}
  ${({ $variant }) => VARIANTS[$variant]}
  position: relative;
  display: inline-flex;
  white-space: nowrap;
  color: ${({ $low, $muted }) => ($low ? colors.primaryStrong : $muted)};

  &[data-hint] {
    cursor: help;
  }

  &[data-hint]:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
    border-radius: 4px;
  }

  &[data-hint]:hover::after,
  &[data-hint]:focus::after {
    content: attr(data-hint);
    position: absolute;
    top: 50%;
    left: calc(100% + 8px);
    z-index: 2;
    transform: translateY(-50%);
    width: max-content;
    max-width: 240px;
    padding: 6px 8px;
    border-radius: 6px;
    background: ${colors.ink800};
    color: ${colors.white};
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    white-space: normal;
    pointer-events: none;
  }
`

const VisuallyHidden = styled.span`
  ${visuallyHidden}
`

interface StockHintProps {
  text: string
  hint?: string
  low?: boolean
  variant?: 'table' | 'mobile'
}

export function StockHint({ text, hint, low = false, variant = 'table' }: StockHintProps): ReactElement {
  return (
    <Anchor
      $low={low}
      $variant={variant}
      $muted={variant === 'table' ? colors.ink400 : colors.ink500}
      data-hint={hint}
      tabIndex={hint ? 0 : undefined}
    >
      {text}
      {hint && <VisuallyHidden>{`. ${hint}`}</VisuallyHidden>}
    </Anchor>
  )
}
